(function () {
  if (window.__ofxSwatchSwapInit) return;
  window.__ofxSwatchSwapInit = true;

  function moneyNumber(value) {
    return parseFloat(String(value || '').replace(/[^0-9,.-]/g, '').replace(/,/g, '')) || 0;
  }

  function replaceButtonText(button, label) {
    var children = button.childNodes;
    var i;
    for (i = children.length - 1; i >= 0; i--) {
      if (children[i].nodeType === 3) button.removeChild(children[i]);
    }
    button.appendChild(document.createTextNode(label));
  }

  function updateSku(card, sku) {
    var skuHost = card.querySelector('.ofx-coll__card-top .sku');
    var label = card.getAttribute('data-ofx-t-sku') || '';
    if (!skuHost) return;
    skuHost.textContent = '';
    if (sku) {
      skuHost.appendChild(document.createTextNode(label + ': '));
      var bold = document.createElement('b');
      bold.textContent = sku;
      skuHost.appendChild(bold);
    }
  }

  function updateStock(card, dot, available, managed, qty) {
    var stock = card.querySelector('.ofx-coll__stock');
    var html;
    if (!stock) return;
    if (!available) {
      html = card.getAttribute('data-ofx-t-out');
    } else if (managed && qty > 0 && qty <= 5) {
      html = card.getAttribute('data-ofx-t-low');
      if (html) html = html.replace('__N__', String(qty));
    } else if (managed && qty > 0) {
      html = card.getAttribute('data-ofx-t-in');
      if (html) html = html.replace('__N__', String(qty));
    } else {
      html = card.getAttribute('data-ofx-t-instock');
    }
    if (html === null || html === undefined) return;
    stock.className = 'ofx-coll__stock';
    if (!available) stock.classList.add('out');
    else if (managed && qty > 0 && qty <= 5) stock.classList.add('low');
    stock.innerHTML = html;
  }

  function updatePrice(card, dot) {
    var row = card.querySelector('.ofx-coll__price-row');
    var now = row && row.querySelector('.price-now');
    var compare = dot.getAttribute('data-ofx-compare') || '';
    var was;
    if (!row || !now) return;
    now.textContent = dot.getAttribute('data-ofx-price') || '';
    was = row.querySelector('.price-was');
    if (compare && moneyNumber(compare) > moneyNumber(now.textContent)) {
      if (!was) {
        was = document.createElement('span');
        was.className = 'price-was';
        row.insertBefore(was, now);
      }
      was.textContent = compare;
    } else if (was) {
      was.parentNode.removeChild(was);
    }
  }

  function railTarget(rail, idx) {
    var slides = rail.querySelectorAll('.ofx-coll__slide');
    var s = slides[idx];
    var railRect;
    var slideRect;
    var target;
    var maxTarget;
    if (!s) return idx * rail.clientWidth;
    railRect = rail.getBoundingClientRect();
    slideRect = s.getBoundingClientRect();
    target = rail.scrollLeft + (slideRect.left - railRect.left) - rail.clientLeft;
    maxTarget = rail.scrollWidth - rail.clientWidth;
    if (target < 0) target = 0;
    if (target > maxTarget) target = maxTarget;
    return target;
  }

  function invalidateRail(card) {
    var rail = card.querySelector('.ofx-coll__rail');
    var settled;
    if (!rail) return;
    card.__ofxRailSeq = (card.__ofxRailSeq || 0) + 1;
    settled = typeof card.__ofxRailSettled === 'number' ? card.__ofxRailSettled : 0;
    if (card.__ofxRailMoving) {
      rail.scrollTo({ left: railTarget(rail, settled), behavior: 'auto' });
      card.__ofxRailMoving = false;
    }
    if (card.__ofxRailPendingImg && card.__ofxRailPendingLoad) {
      card.__ofxRailPendingImg.removeEventListener('load', card.__ofxRailPendingLoad);
    }
    if (card.__ofxRailPendingImg && card.__ofxRailPendingError) {
      card.__ofxRailPendingImg.removeEventListener('error', card.__ofxRailPendingError);
    }
    window.clearTimeout(card.__ofxRailPendingTimer);
    card.__ofxRailPendingImg = null;
    card.__ofxRailPendingLoad = null;
    card.__ofxRailPendingError = null;
    card.__ofxRailPendingTimer = null;
  }

  function moveRail(card, dot) {
    var slideValue = dot.getAttribute('data-ofx-slide');
    var rail = card.querySelector('.ofx-coll__rail');
    var idx;
    var slide;
    var image;
    var seq;
    var timer;
    var started = false;
    var ticks = 0;
    function settle() {
      var target;
      if (card.__ofxRailSeq !== seq) return;
      ticks++;
      target = railTarget(rail, idx);
      if (Math.abs(rail.scrollLeft - target) < 1 || ticks > 180) {
        card.__ofxRailSettled = idx;
        card.__ofxRailMoving = false;
        return;
      }
      window.requestAnimationFrame(settle);
    }
    function start() {
      if (started || card.__ofxRailSeq !== seq || !rail) return;
      started = true;
      window.clearTimeout(timer);
      if (image) {
        image.removeEventListener('load', start);
        image.removeEventListener('error', start);
      }
      if (card.__ofxRailPendingImg === image) {
        card.__ofxRailPendingImg = null;
        card.__ofxRailPendingLoad = null;
        card.__ofxRailPendingError = null;
        card.__ofxRailPendingTimer = null;
      }
      rail.scrollTo({
        left: railTarget(rail, idx),
        behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      card.__ofxRailMoving = true;
      window.requestAnimationFrame(settle);
    }
    if (slideValue === null || !rail) return;
    idx = parseInt(slideValue, 10);
    if (isNaN(idx)) return;
    seq = card.__ofxRailSeq;
    slide = rail.querySelectorAll('.ofx-coll__slide')[idx];
    image = slide && slide.querySelector('img');
    if (!image || image.complete) {
      start();
      return;
    }
    image.setAttribute('loading', 'eager');
    timer = window.setTimeout(start, 300);
    card.__ofxRailPendingImg = image;
    card.__ofxRailPendingLoad = start;
    card.__ofxRailPendingTimer = timer;
    image.addEventListener('load', start, { once: true });
    if (typeof image.decode === 'function') {
      try {
        image.decode().then(start, start);
      } catch (ignore) {
        card.__ofxRailPendingError = start;
        image.addEventListener('error', start, { once: true });
      }
    } else {
      card.__ofxRailPendingError = start;
      image.addEventListener('error', start, { once: true });
    }
  }

  function legacySwapSrc(dot) {
    var card = dot.closest('.ofx-coll__card');
    var img = card && card.querySelector('.ofx-coll__card-image img');
    var src = dot.getAttribute('data-ofx-swap-src');
    var srcset;
    var row;
    if (!img || !src) return;
    srcset = dot.getAttribute('data-ofx-swap-srcset');
    if (srcset) {
      img.setAttribute('srcset', srcset);
    } else {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    }
    img.src = src;
    row = dot.closest('.ofx-coll__color-row');
    if (row) {
      row.querySelectorAll('.sw').forEach(function (s) { s.classList.remove('active'); });
    }
    dot.classList.add('active');
  }

  function activate(dot) {
    var card = dot.closest('.ofx-coll__card');
    var row;
    var form;
    var idInput;
    var button;
    var imageLink;
    var titleLink;
    var available;
    var managed;
    var qty;
    var url;
    var more;
    if (!card) return;
    invalidateRail(card);
    if (!dot.getAttribute('data-ofx-vid')) {
      legacySwapSrc(dot);
      return;
    }
    row = dot.closest('.ofx-coll__color-row');
    if (row) {
      row.querySelectorAll('.sw').forEach(function (swatch) {
        swatch.classList.remove('active');
        if (swatch.hasAttribute('aria-pressed')) swatch.setAttribute('aria-pressed', 'false');
      });
    }
    dot.classList.add('active');
    if (dot.hasAttribute('aria-pressed')) dot.setAttribute('aria-pressed', 'true');
    more = card.querySelector('.ofx-coll__color-row .more');
    if (more) more.classList.toggle('has-active', !!dot.closest('.more'));
    available = dot.getAttribute('data-ofx-avail') === 'true';
    managed = dot.getAttribute('data-ofx-managed') === 'true';
    qty = parseInt(dot.getAttribute('data-ofx-qty'), 10) || 0;
    updateSku(card, dot.getAttribute('data-ofx-sku') || '');
    updateStock(card, dot, available, managed, qty);
    updatePrice(card, dot);
    form = card.querySelector('form[data-ofx-add-form]');
    idInput = form && form.querySelector('input[name="id"]');
    button = card.querySelector('[data-ofx-add-btn]');
    if (idInput) idInput.value = dot.getAttribute('data-ofx-vid') || '';
    if (button) {
      button.disabled = !available;
      replaceButtonText(button, available ? card.getAttribute('data-ofx-t-add') : card.getAttribute('data-ofx-t-soldout'));
    }
    url = dot.getAttribute('data-ofx-url');
    imageLink = card.querySelector('a.ofx-coll__card-image');
    titleLink = card.querySelector('a.ofx-coll__card-name');
    if (url) {
      if (imageLink) imageLink.setAttribute('href', url);
      if (titleLink) titleLink.setAttribute('href', url);
    }
    moveRail(card, dot);
  }

  function resnapRails() {
    var rails = document.querySelectorAll('.ofx-coll__rail');
    rails.forEach(function (rail) {
      var card = rail.closest('.ofx-coll__card');
      var active = card && card.querySelector('.ofx-coll__color-row .sw.active');
      var slideValue = active && active.getAttribute('data-ofx-slide');
      var idx;
      if (card && card.__ofxRailPendingImg) return;
      if (slideValue === null || !rail) return;
      idx = parseInt(slideValue, 10);
      if (isNaN(idx)) return;
      rail.scrollTo({ left: railTarget(rail, idx), behavior: 'auto' });
    });
  }

  var resizeQueued = false;
  window.addEventListener('resize', function () {
    if (resizeQueued) return;
    resizeQueued = true;
    window.requestAnimationFrame(function () {
      resizeQueued = false;
      resnapRails();
    });
  }, { passive: true });

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('.ofx-coll__color-row [data-ofx-swap]');
    if (!dot) return;
    event.preventDefault();
    event.stopPropagation();
    activate(dot);
  });

  document.addEventListener('keydown', function (event) {
    var dot;
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    dot = event.target.closest('.ofx-coll__color-row [data-ofx-swap]');
    if (!dot) return;
    event.preventDefault();
    activate(dot);
  });
})();
